import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Route, Switch } from 'react-router-dom';
import _ from 'lodash';
import { AppRoute, AppRouter } from './components';
import DefaultLayout from './components/layout/DefaultLayout';
import PublicLayout from './components/layout/PublicLayout';
import { OverrideService } from './logic/services';
import { appMountedAction } from './logic/store/AppActions';
import { refreshAuthAction } from './modules/auth/AuthActions';
// import  AuthService  from '../admin/logic/services';

class App extends Component {
  getInnerPaths() {
    // if(props.match.params && props.match.params.locale) {
    //   locale = props.match.params.locale;
    // }

    // let url = props.match.path;
    // url = url.replace(/\/$/, '');

    const customRoutes = OverrideService.getRoutes();

    return (
      <Switch>
        {_.isArray(customRoutes) ? customRoutes : customRoutes()}
        {/* <AppRoute path={`${url}/login`} component={PublicLayout}  unAuthenticatedOnly /> */}
        <AppRoute
          path="/forgot-password"
          component={PublicLayout}
          unAuthenticatedOnly
        />
        <AppRoute path="/login" component={PublicLayout} />
        <AppRoute path="/" component={DefaultLayout} authenticatedOnly />
      </Switch>
    );
  }

  render() {
    if (!this.props.ready) return null;

    const InnerRouting = props => this.getInnerPaths(props);

    return (
      <AppRouter>
        <div className="App">
          <Switch>
            <Route path="/" component={InnerRouting} />
          </Switch>
          <div id="modalHolder" className="modal-holder" />
        </div>
      </AppRouter>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    appMounted: () => {
      return dispatch(appMountedAction());
    },
    refreshAuth: () => {
      return dispatch(refreshAuthAction());
    }
  };
};

const mapStateToProps = state => {
  return {
    ready: state.ready
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
